var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "card" }, [
    _c("div", { staticClass: "card-body pb-0" }, [
      _c("span", { staticClass: "badge bg-dark" }, [
        _vm._v(_vm._s(_vm._f("translate")("Assignment"))),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card-body" }, [
      _c("div", {
        domProps: { innerHTML: _vm._s(_vm.component.data.assignment.html) },
      }),
      _vm._v(" "),
      _vm.component.data.assignment_img
        ? _c("div", [
            _c("img", {
              staticClass: "img-fluid",
              attrs: {
                src: _vm.imageUrl(_vm.component.data.assignment_img),
                alt: "",
              },
            }),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        [
          _c(
            "button",
            {
              staticClass: "btn btn-primary btn-sm fw-bold",
              on: { click: _vm.toggleSolution },
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm._f("translate")("Solution")) +
                  "\n      "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "transition",
            { attrs: { name: "component-fade", mode: "out-in" } },
            [
              _vm.showSolution
                ? _c("div", { key: "1" }, [
                    _c("div", {
                      staticClass: "mt-4",
                      domProps: {
                        innerHTML: _vm._s(_vm.component.data.solution.html),
                      },
                    }),
                    _vm._v(" "),
                    _vm.component.data.solution_img
                      ? _c("div", { staticClass: "mt-4" }, [
                          _c("img", {
                            staticClass: "img-fluid",
                            attrs: {
                              src: _vm.imageUrl(
                                _vm.component.data.solution_img
                              ),
                              alt: "",
                            },
                          }),
                        ])
                      : _vm._e(),
                  ])
                : _vm._e(),
            ]
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }